// Responsive inline sources; canonical full-size originals remain in image metadata and lightboxes.
import gastricDiagram320 from "@/assets/gastric-bypass-diagram-320.webp.asset.json";
import gastricDiagram406 from "@/assets/gastric-bypass-diagram-406.webp.asset.json";
import bypassGraph480 from "@/assets/bypass-weight-loss-graph-480.webp.asset.json";
import bypassGraph800 from "@/assets/bypass-weight-loss-graph-800.webp.asset.json";
import bypassGraph1200 from "@/assets/bypass-weight-loss-graph-1200.webp.asset.json";
import bypassGraph1664 from "@/assets/bypass-weight-loss-graph-1664.webp.asset.json";
import bandDiagram480 from "@/assets/lap-band-diagram-480.webp.asset.json";
import bandDiagram800 from "@/assets/lap-band-diagram-800.webp.asset.json";
import bandDiagram900 from "@/assets/lap-band-diagram-900.webp.asset.json";
import oversizedSleeveOriginalEn from "@/assets/sleeve-to-bypass-first-view-en.png.asset.json";
import oversizedSleeveOriginalEs from "@/assets/sleeve-to-bypass-first-view-es.png.asset.json";
import dissectedSleeveOriginal from "@/assets/sleeve-to-bypass-dissection.png.asset.json";
import completedPouchEnOriginal from "@/assets/sleeve-to-bypass-completed-en.png.asset.json";
import completedPouchEsOriginal from "@/assets/sleeve-to-bypass-completed-es.png.asset.json";
import oversizedSleeveEn320 from "@/assets/sleeve-to-bypass-first-view-en-320.webp.asset.json";
import oversizedSleeveEn640 from "@/assets/sleeve-to-bypass-first-view-en-640.webp.asset.json";
import oversizedSleeveEn1200 from "@/assets/sleeve-to-bypass-first-view-en-1200.webp.asset.json";
import oversizedSleeveEs320 from "@/assets/sleeve-to-bypass-first-view-es-320.webp.asset.json";
import oversizedSleeveEs640 from "@/assets/sleeve-to-bypass-first-view-es-640.webp.asset.json";
import oversizedSleeveEs1200 from "@/assets/sleeve-to-bypass-first-view-es-1200.webp.asset.json";
import dissectedSleeve320 from "@/assets/sleeve-to-bypass-dissection-320.webp.asset.json";
import dissectedSleeve640 from "@/assets/sleeve-to-bypass-dissection-640.webp.asset.json";
import dissectedSleeve976 from "@/assets/sleeve-to-bypass-dissection-976.webp.asset.json";
import completedPouchEn320 from "@/assets/sleeve-to-bypass-completed-en-320.webp.asset.json";
import completedPouchEn640 from "@/assets/sleeve-to-bypass-completed-en-640.webp.asset.json";
import completedPouchEs320 from "@/assets/sleeve-to-bypass-completed-es-320.webp.asset.json";
import completedPouchEs640 from "@/assets/sleeve-to-bypass-completed-es-640.webp.asset.json";
import refluxPost480 from "@/assets/sleeve-ugi-reflux-post-736-480.webp.asset.json";
import refluxPost736 from "@/assets/sleeve-ugi-reflux-post-736-736.webp.asset.json";
import dilatedPouch from "@/assets/bypass-revision-oversized-pouch-en.webp.asset.json";
import dilatedPouch320 from "@/assets/bypass-revision-oversized-pouch-en-320.webp.asset.json";
import dilatedPouch640 from "@/assets/bypass-revision-oversized-pouch-en-640.webp.asset.json";
import dilatedPouch1200 from "@/assets/bypass-revision-oversized-pouch-en-1200.webp.asset.json";
import bougieStapling from "@/assets/bypass-revision-downsizing-en.webp.asset.json";
import bougieStapling320 from "@/assets/bypass-revision-downsizing-en-320.webp.asset.json";
import bougieStapling640 from "@/assets/bypass-revision-downsizing-en-640.webp.asset.json";
import bougieStapling1200 from "@/assets/bypass-revision-downsizing-en-1200.webp.asset.json";
import revisionCompleted from "@/assets/bypass-revision-completed-pouch-en.webp.asset.json";
import revisionCompleted320 from "@/assets/bypass-revision-completed-pouch-en-320.webp.asset.json";
import revisionCompleted640 from "@/assets/bypass-revision-completed-pouch-en-640.webp.asset.json";
import revisionCompleted1200 from "@/assets/bypass-revision-completed-pouch-en-1200.webp.asset.json";
import dilatedPouchEs from "@/assets/bypass-revision-oversized-pouch-es.webp.asset.json";
import dilatedPouchEs320 from "@/assets/bypass-revision-oversized-pouch-es-320.webp.asset.json";
import dilatedPouchEs640 from "@/assets/bypass-revision-oversized-pouch-es-640.webp.asset.json";
import dilatedPouchEs1200 from "@/assets/bypass-revision-oversized-pouch-es-1200.webp.asset.json";
import bougieStaplingEs from "@/assets/bypass-revision-downsizing-es.webp.asset.json";
import bougieStaplingEs320 from "@/assets/bypass-revision-downsizing-es-320.webp.asset.json";
import bougieStaplingEs640 from "@/assets/bypass-revision-downsizing-es-640.webp.asset.json";
import bougieStaplingEs1200 from "@/assets/bypass-revision-downsizing-es-1200.webp.asset.json";
import revisionCompletedEs from "@/assets/bypass-revision-completed-pouch-es.webp.asset.json";
import revisionCompletedEs320 from "@/assets/bypass-revision-completed-pouch-es-320.webp.asset.json";
import revisionCompletedEs640 from "@/assets/bypass-revision-completed-pouch-es-640.webp.asset.json";
import revisionCompletedEs1200 from "@/assets/bypass-revision-completed-pouch-es-1200.webp.asset.json";

export const gastricDiagramResponsive = {
  src: gastricDiagram320.url,
  srcSet: `${gastricDiagram320.url} 320w, ${gastricDiagram406.url} 406w`,
} as const;
export const bypassGraphResponsive = {
  src: bypassGraph480.url,
  srcSet: `${bypassGraph480.url} 480w, ${bypassGraph800.url} 800w, ${bypassGraph1200.url} 1200w, ${bypassGraph1664.url} 1664w`,
} as const;
export const bandDiagramResponsive = {
  src: bandDiagram480.url,
  srcSet: `${bandDiagram480.url} 480w, ${bandDiagram800.url} 800w, ${bandDiagram900.url} 900w`,
} as const;
export const oversizedSleeveResponsive = {
  src: oversizedSleeveEn320.url,
  srcSet: `${oversizedSleeveEn320.url} 320w, ${oversizedSleeveEn640.url} 640w, ${oversizedSleeveEn1200.url} 1200w`,
} as const;
export const oversizedSleeveResponsiveEs = {
  src: oversizedSleeveEs320.url,
  srcSet: `${oversizedSleeveEs320.url} 320w, ${oversizedSleeveEs640.url} 640w, ${oversizedSleeveEs1200.url} 1200w`,
} as const;
export const dissectedSleeveResponsive = {
  src: dissectedSleeve320.url,
  srcSet: `${dissectedSleeve320.url} 320w, ${dissectedSleeve640.url} 640w, ${dissectedSleeve976.url} 976w`,
} as const;
export const completedPouchResponsiveEn = {
  src: completedPouchEn320.url,
  srcSet: `${completedPouchEn320.url} 320w, ${completedPouchEn640.url} 640w`,
} as const;
export const completedPouchResponsiveEs = {
  src: completedPouchEs320.url,
  srcSet: `${completedPouchEs320.url} 320w, ${completedPouchEs640.url} 640w`,
} as const;
export const refluxPostResponsive = {
  src: refluxPost480.url,
  srcSet: `${refluxPost480.url} 480w, ${refluxPost736.url} 736w`,
} as const;

export const revisionGalleryResponsive: Record<string, { src: string; srcSet: string }> = {
  [dilatedPouch.url]: {
    src: dilatedPouch320.url,
    srcSet: `${dilatedPouch320.url} 320w, ${dilatedPouch640.url} 640w, ${dilatedPouch1200.url} 1200w`,
  },
  [bougieStapling.url]: {
    src: bougieStapling320.url,
    srcSet: `${bougieStapling320.url} 320w, ${bougieStapling640.url} 640w, ${bougieStapling1200.url} 1200w`,
  },
  [revisionCompleted.url]: {
    src: revisionCompleted320.url,
    srcSet: `${revisionCompleted320.url} 320w, ${revisionCompleted640.url} 640w, ${revisionCompleted1200.url} 1200w`,
  },
  [dilatedPouchEs.url]: {
    src: dilatedPouchEs320.url,
    srcSet: `${dilatedPouchEs320.url} 320w, ${dilatedPouchEs640.url} 640w, ${dilatedPouchEs1200.url} 1200w`,
  },
  [bougieStaplingEs.url]: {
    src: bougieStaplingEs320.url,
    srcSet: `${bougieStaplingEs320.url} 320w, ${bougieStaplingEs640.url} 640w, ${bougieStaplingEs1200.url} 1200w`,
  },
  [revisionCompletedEs.url]: {
    src: revisionCompletedEs320.url,
    srcSet: `${revisionCompletedEs320.url} 320w, ${revisionCompletedEs640.url} 640w, ${revisionCompletedEs1200.url} 1200w`,
  },
  [oversizedSleeveOriginalEn.url]: oversizedSleeveResponsive,
  [oversizedSleeveOriginalEs.url]: oversizedSleeveResponsiveEs,
  [dissectedSleeveOriginal.url]: dissectedSleeveResponsive,
  [completedPouchEnOriginal.url]: completedPouchResponsiveEn,
  [completedPouchEsOriginal.url]: completedPouchResponsiveEs,
};
